module.exports = __webpack_public_path__ + "static/media/logodefaultimage.5d746bf2.png";